

import { Link } from 'react-router-dom';
import { Button } from 'antd';
import notfound from '../Images/notfound.png';

function NotFoundPage() {

    return (
        <>
            <section className="Login-Form-Page">
                <div className="loginleft">
                    <div>
                        <div className="notfound">
                            <img src={notfound} alt=""></img>
                        </div>
                        <h3>404 Not Found</h3>
                        <Link to="/dashboard">
                            <Button type="primary">
                                Back To Home
                            </Button>
                        </Link>
                    </div>
                </div>

            </section>
        </>
    );
}

export default NotFoundPage;
